module.exports = __webpack_public_path__ + "img/banner25-3.a5a61cdc.jpg";